import { Skeleton } from '@cian/ui-kit/skeleton';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './ListingHeaderSkeleton.css';

export interface IListingHeaderSkeletonProps {
  className?: string;
}

export const ListingHeaderSkeleton: React.FC<IListingHeaderSkeletonProps> = ({ className }) => {
  return (
    <div className={cn(styles['root'], className)} data-testid="listing-header-skeleton">
      <div className={styles['breadcrumbs']}>
        <Skeleton width={160} height={19} borderRadius={8} />
        <Skeleton width={70} height={19} borderRadius={8} />
      </div>
      <Skeleton className={styles['heading']} width="70%" height={28} borderRadius={8} />
      <Skeleton className={styles['sort']} width={130} height={24} borderRadius={8} />
    </div>
  );
};

ListingHeaderSkeleton.displayName = 'ListingHeaderSkeleton';
